import { media } from '../ui';
import { fontFamily } from './fonts';

export function appearanceVariables(settings) {
  if (!settings) return {};
  const vars = {};
  for (const [key, group] of Object.entries(settings.typography)) {
    vars[`--ap-${key}-font`] = fontFamily(group.font);
    vars[`--ap-${key}-size`] = `${group.size}px`;
    vars[`--ap-${key}-mobile-size`] = `${group.mobile_size}px`;
    vars[`--ap-${key}-weight`] = group.weight;
    vars[`--ap-${key}-color`] = group.color;
  }
  vars['--ap-button-background'] = settings.typography.buttons.background;
  vars['--ap-image-border'] = settings.image_borders ? '1px solid #c3a572' : 'none';
  vars['--ap-image-shadow'] = settings.image_shadows ? '0 8px 22px rgba(28,32,51,.16)' : 'none';
  return vars;
}

export function backgroundStyle(bg) {
  if (!bg) return {};
  const opacity = bg.darkening / 100;
  const url = bg.image ? media(bg.image) : '';
  return {
    backgroundColor: bg.color,
    backgroundImage: url ? `linear-gradient(rgba(0,0,0,${opacity}),rgba(0,0,0,${opacity})),url(${JSON.stringify(url)})` : 'none',
    backgroundSize: bg.fit,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: `${bg.position_x}% ${bg.position_y}%`,
    ...(bg.text_color ? { '--ap-body-color': bg.text_color, '--ap-headings-color': bg.text_color } : {}),
  };
}

export function currentPageKey(path, site) {
  if (path === '/') return 'page:' + (site.pages.find(p => p.slug === '')?.id || 'home');
  if (path.startsWith('/page/')) return 'page:' + (site.pages.find(p => p.slug === decodeURIComponent(path.slice(6)))?.id || 'unknown');
  if (path.startsWith('/produit/')) return 'product';
  if (path.startsWith('/commande/')) return 'order';
  return ({ '/boutique': 'catalog', '/savons': 'soaps', '/panier': 'cart' })[path] || 'other';
}

export const defaultBackground = () => ({ color: '#f7f2ec', image: '', position_x: 50, position_y: 50, fit: 'cover', darkening: 0, text_color: null });

export function contrastRatio(a, b) {
  const luminance = hex => {
    const c = hex.slice(1).match(/.{2}/g).map(x => parseInt(x, 16) / 255).map(x => x <= 0.04045 ? x / 12.92 : ((x + .055) / 1.055) ** 2.4);
    return c[0] * .2126 + c[1] * .7152 + c[2] * .0722;
  };
  const x = luminance(a), y = luminance(b);
  return (Math.max(x, y) + .05) / (Math.min(x, y) + .05);
}